import { render } from "./XgPlayer.vue?vue&type=template&id=331aaf6a&scoped=true"
import script from "./XgPlayer.vue?vue&type=script&lang=js"
export * from "./XgPlayer.vue?vue&type=script&lang=js"

import "./XgPlayer.vue?vue&type=style&index=0&id=331aaf6a&lang=scss&scoped=true"

import exportComponent from "/Users/yishen/fulai/project/live-streaming/web-liveplay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-331aaf6a"]])

export default __exports__